import { render, staticRenderFns } from "./Clientes.view.vue?vue&type=template&id=040b9c0a"
import script from "./Clientes.view.vue?vue&type=script&lang=js"
export * from "./Clientes.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports